import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  contributors: hasMany('product-track-contributor', {
    inverse: 'productTrack',
  }),
  productElement: belongsTo('product-element', { inverse: null }),
  productWorks: hasMany('product-work', { inverse: null }),
});
